import lottie from 'lottie-web';

export default class LottieIllustration {
    #containerEl;
    #options;
    #instance;
    #totalFrames;
    #isStopped = true;

    constructor(containerEl, options = {
        path: '',
        animationData: {},
        loop: false,
        autoplay: false,
        loopFromFrame: null,
        onComplete: () => {}
    }) {
        this.#containerEl = containerEl;
        this.#options = options;

        this.init();
    }

    get instance() {
        return this.#instance;
    }

    init() {
        const {
            path, loop, autoplay, animationData
        } = this.#options;

        this.#instance = lottie.loadAnimation({
            container: this.#containerEl,
            renderer: 'svg',
            loop,
            autoplay,
            animationData,
            path
        });

        this.#instance.addEventListener('data_failed', () => {
            console.log(`Lottie ${path} failed to load`);
        });

        this.#instance.addEventListener('DOMLoaded', () => {
            this.#totalFrames = this.#instance.totalFrames;
            console.log(`Lottie ${path} loaded`);
        });

    }

    play() {
        this.#instance.addEventListener('complete', this.completeCallback);
        this.#instance.play();
    }

    completeCallback = () => {
        this.#options.onComplete?.();

        const { loopFromFrame } = this.#options;

        if (!loopFromFrame) return;

        this.#instance.playSegments([[loopFromFrame, this.#totalFrames]], false);
    };

    stop() {
        this.#instance.stop();
    }

    reset() {
        this.#instance.removeEventListener('complete', this.completeCallback);
        this.#instance.resetSegments(true);
        this.#instance.goToAndStop(0, true);
    }

    pause() {
        this.#instance.pause();
    }
}
